import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";
import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { query_dispatcher_get, sync_command_dispatcher } from "@/api/client";
import { RemittanceRepository, Remittance } from "../domain/Remittance";
import { v4 as uuidv4 } from 'uuid';

export class ApiRemittanceRepository implements RemittanceRepository {

    command_dispatcher: CommandDispatcher
    query_dispatcher: QueryDispatcher
    constructor() {
        this.command_dispatcher = sync_command_dispatcher
        this.query_dispatcher = query_dispatcher_get
    }

    api_to_domain(remittance) {

        let r =  new Remittance(
            remittance.uuid,
            remittance.company_id,
            remittance.date.replace('T', ' ').replace('-', '/').replace('-', '/'),
            remittance.invoices,
            remittance.total_amount,
            remittance.xml,
            remittance.deleted,
            remittance.state
        );
        return r;
    }

    async get_remitances(company_id:Number): Promise<{results: Remittance[], count: number}> {
        let args = { 
            args:{company_id: company_id},
            force_get: true,
        };
        let res = await this.query_dispatcher.dispatch('get.remittance.list', args)
        // console.log('--------------------------fsdf')
        // console.log(res)
        let remittanceList: Remittance[] = []
        for (let i in res['results']) {
            remittanceList.push(this.api_to_domain(res['results'][i]))
        }
        return {'results': remittanceList, 'count': res['count']}
    }

    async unremit_remittance(rem_uuid: string) {
        let res = await this.command_dispatcher.dispatch('change.state.remittance.invoices', { rem_uuid: rem_uuid, state: 'pending' })
        return res['output']
    }

    async mark_as_paid_remittance(rem_uuid: string) {
        let res = await this.command_dispatcher.dispatch('change.state.remittance.invoices', { rem_uuid: rem_uuid, state: 'paid' })
        return res['output']
    }

    async delete(remittance_ids: string[]) {
        let res = await this.command_dispatcher.dispatch('delete.remittances', { remittance_ids: remittance_ids })
        return res['output']
    }
}